const TaxReceiptRequiredReasonEnum = Object.freeze({
    CART_IS_OVER_LIMIT: 'CART_IS_OVER_LIMIT',
    ORDER_IS_OVER_LIMIT: 'ORDER_IS_OVER_LIMIT',
    ORDER_WAS_OVER_LIMIT: 'ORDER_WAS_OVER_LIMIT',
});

module.exports = TaxReceiptRequiredReasonEnum;
